/**
 * 规划中模块骨架页
 *
 * 用于「招标文件编写」「招标信息筛选」两个模块：入口已就位，展示该模块的规划能力与边界，
 * 具体功能按需求逐步实现。投标文件编写模块不使用本页面。
 */
import React from 'react';
import { ArrowLeftIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { AppModuleMeta } from './modules';

interface PlannedModulePageProps {
  module: AppModuleMeta;
  onBack: () => void;
}

const PlannedModulePage: React.FC<PlannedModulePageProps> = ({ module, onBack }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center justify-between">
          <button
            onClick={onBack}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-lg text-gray-600 bg-gray-100 hover:bg-gray-200 hover:text-gray-800 transition-colors"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-1.5" />
            返回模块选择
          </button>
          <span className="text-xs text-gray-400">工作台 / {module.name}</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center space-x-3">
          <h1 className="text-2xl font-semibold text-gray-900">{module.name}</h1>
          <span className="px-2 py-0.5 rounded text-xs bg-amber-50 text-amber-700 border border-amber-200">
            {module.statusLabel}
          </span>
        </div>
        <p className="mt-3 text-sm text-gray-500 leading-relaxed">{module.summary}</p>
        <p className="mt-1 text-xs text-gray-400">适用：{module.audience}</p>

        <div className="mt-8 bg-white rounded-xl border border-gray-200 shadow-sm p-6">
          <div className="flex items-center space-x-2">
            <WrenchScrewdriverIcon className="w-5 h-5 text-gray-400" />
            <h2 className="text-sm font-semibold text-gray-900">模块正在建设中</h2>
          </div>
          <p className="mt-3 text-sm text-gray-500 leading-relaxed">
            该模块入口已就位，功能按需求逐步实现。以下为规划能力清单，确认范围后在该分支内继续开发。
          </p>

          <div className="mt-6">
            <div className="text-xs font-medium text-gray-500 mb-3">规划能力</div>
            <ul className="space-y-2">
              {module.capabilities.map((item) => (
                <li key={item} className="flex items-start text-sm text-gray-600">
                  <span className="mt-2 mr-2.5 w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0" />
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlannedModulePage;
